'use strict';

import {ewModel} from './ewmodel.js';

export class ngDepModel extends ewModel
{
	_services = {
	}

	constructor(itemData, $filter, jsDataService){
		super(itemData);
		this._services.$filter = $filter;
		this._services.jsDataService = jsDataService;
	}

	s(name){
		if(typeof(this._services[name]) !== 'undefined'){
			return this._services[name];
		}
		return null;
	}

	getTitledValue(name){
		if(typeof(this[name + '_title']) !== 'undefined'){
			return this[name + '_title'];
		}
		return '';
	}

	getDisplayValue(name){
		if(typeof(this[name + '_display']) !== 'undefined'){
			return this[name + '_display'];
		}
		return '';
	}

	getOnValue(name){
		if(typeof(this[name + '_on']) !== 'undefined' && (true === this[name + '_on'] || 1 === this[name + '_on'] || '1' === this[name + '_on'])){
			return this[name];
		}
		return '';
	}

    getClassifValue(name, classifName){
        let classif = this.s('jsDataService').get('cfgClassif') || {};

        if (Array.isArray(classif)) {
            classif = { [classifName]: classif };
        }

        if (!classif[classifName]) {
            const keys = Object.keys(classif);
            if (keys.length === 1) {
                classif[classifName] = classif[keys[0]];
            }
        }

        let list = classif[classifName];

        if (list && !Array.isArray(list) && typeof list === 'object') {
            list = Object.values(list);
        }

        if (!Array.isArray(list)) return '';

        const matchById = (id) => {
            const sid = String(id);
            const found = this.s('$filter')('filter')(list, (i) => String(i.id) === sid, true);
            return found.length ? found[0].title : null;
        };

        const val = this[name];
        if (val == null || val === '') return '';

        if (Array.isArray(val)) {
            return val.map(matchById).filter(Boolean).join(', ');
        }
        if (typeof val === 'object') {
            return Object.values(val).map(matchById).filter(Boolean).join(', ');
        }

        return matchById(val) || '';
    }


    getData(){
		let obj = Object.assign({}, angular.copy(this));
		delete obj._services;
		return obj;
	}
}
